export const convertToIndianWords = (amount: number): string => {
  if (amount === 0) return 'zero';

  const crore = Math.floor(amount / 10000000);
  const lakh = Math.floor((amount % 10000000) / 100000);
  const thousand = Math.floor((amount % 100000) / 1000);
  const hundred = Math.floor((amount % 1000) / 100);
  const remainder = amount % 100;

  const ones = ['', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
  const teens = [
    'ten',
    'eleven',
    'twelve',
    'thirteen',
    'fourteen',
    'fifteen',
    'sixteen',
    'seventeen',
    'eighteen',
    'nineteen',
  ];
  const tens = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];

  const convertBelow100 = (num: number): string => {
    if (num < 10) return ones[num];
    if (num < 20) return teens[num - 10];
    return tens[Math.floor(num / 10)] + (num % 10 ? ` ${ones[num % 10]}` : '');
  };

  const parts = [];
  if (crore) parts.push(`${convertBelow100(crore)} crore`);
  if (lakh) parts.push(`${convertBelow100(lakh)} lakh`);
  if (thousand) parts.push(`${convertBelow100(thousand)} thousand`);
  if (hundred) parts.push(`${ones[hundred]} hundred`);
  if (remainder) parts.push(convertBelow100(remainder));

  return parts.join(' ');
};
